import React, { useMemo } from "react";
import { useAtom } from "jotai";
import { usersState } from "../../../state";

import UserStatsCards from "./components/user.stats.cards";
import UserTable from "./components/user.table.listing";
import {
  useGetUsersWithParams,
} from "../../../hooks";
import dayjs from "dayjs";

const UserManagementPage = () => {
  const [users] = useAtom(usersState);

  const last30dCutOffDate = useMemo(
    () => dayjs().subtract(1, "month").toISOString(),
    []
  );

  const {
    data: activeUsersData,
    isError,
    isLoading,
  } = useGetUsersWithParams({ lastLoggedInAfter: last30dCutOffDate });

  const {
    data: disabledUsersData,
    isError: isDisabledError,
    isLoading: isDisabledLoading,
  } = useGetUsersWithParams({ enabled: false });

  const {
    data: unverifedUsersData,
    isError: isUnverifiedError,
    isLoading: isUnverifiedLoading,
  } = useGetUsersWithParams({ isEmailVerified: false });

  const {
    data: allUsersData,
    isError: allUsersError,
    isLoading: allUsersLoading,
  } = useGetUsersWithParams();

  const stats = {
    total: allUsersData && allUsersData.page.totalElements,
    active: activeUsersData && activeUsersData.page.totalElements,
    disabled: disabledUsersData && disabledUsersData.page.totalElements,
    unverified: unverifedUsersData && unverifedUsersData.page.totalElements,
  };

  return (
    <React.Fragment>
      <UserStatsCards stats={stats} />
      <UserTable users={users} />
    </React.Fragment>
  );
};

export default UserManagementPage;
